// Заглушка глобала SVGAnimatedString для неполных JS-сред.
//
// v-tooltip на загрузке модуля запоминает `window.SVGAnimatedString`
// (dist/v-tooltip.esm.js, строки 10–13) и потом делает
// `el.className instanceof SVGAnimatedString`. В настоящих браузерах интерфейс
// есть всегда, но у ботов и ИИ-агентов с урезанной средой (UA подменён на
// Chrome) там undefined: каждый v-tooltip при bind кидал «Right-hand side of
// 'instanceof' is not an object», страница не дорисовывалась, а Rollbar получал
// по событию на подсказку — агент клиента забил месячный лимит (2026-10-02..04).
// Пустой класс возвращает instanceof → false, и v-tooltip идёт по ветке
// строкового className.
//
// Срабатывает побочным эффектом импорта, поэтому в main.js импорт этого файла
// обязан стоять ПЕРВЫМ — раньше любого модуля, который тянет v-tooltip.
export function ensureSvgAnimatedString(root) {
  if (!root || typeof root.SVGAnimatedString === "function") return;
  try {
    root.SVGAnimatedString = function SVGAnimatedString() {};
  } catch (e) {
    // Нестандартная среда с read-only свойством — оставляем как есть.
  }
}

if (typeof window !== "undefined") ensureSvgAnimatedString(window);
